<template>
  <div class="hiq-article-list__tag-filter hiq-article-list__filter hiq-search-filter">
    <label
      class="hiq-article-list__tag-filter-label hiq-search-filter__label"
      :for="'multiselect-' + tag.name">
        {{ tag.name }}
    </label>
    <button
        class="hiq-article-list__tag-filter-btn hiq-search-filter__btn"
        :data-toggle="'#filterContainer-' + tag.name"
        :id="'multiselect-' + tag.name"
        data-close-outside>
        <span class="hiq-article-list__tag-filter-btn__text hiq-search-filter__btn-text">Alla</span>
    </button>
    <div
      class="hiq-article-list__tag-filter-options hiq-search-filter__options"
      :id="'filterContainer-' + tag.name">
      <div
        class="hiq-article-list__tag-filter-option hiq-search-filter__option"
        :class="option.selected ? 'checked' : ''"
        v-for="(option, index) in tag.options"
        :key="index">
        <label
          :for="option.name"
          class="hiq-article-list__tag-filter-option__label hiq-search-filter__option-label">
          <input
            class="hiq-article-list__tag-filter-option__checkbox hiq-search-filter__option-checkbox"
            type="checkbox"
            :id="option.name"
            v-model="option.selected"
            @change="onSelectFilter(tag.name, option)"
          />
            {{ option.title }}
          <span
            class="hiq-article-list__tag-filter-option__checkbox-custom
            hiq-search-filter__option-checkbox__custom">
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { ITagOption } from "../store/state";
import { search } from "../store/actions";

interface TagFilterProps {
  tag: {};
}

interface TagFilterMethods {
  getSelectedOptions(options: ITagOption[]): ITagOption[];
  onSelectFilter(tagName: string): void;
  updateSelectedFilters(setFilter: string, selectedOptions: ITagOption[]): void;
}

export default Vue.extend<{}, TagFilterMethods, {}, TagFilterProps>({
  name: "TagFilter",
  props: {
    tag: {},
  },
  computed: {},
  methods: {
    getSelectedOptions(options: ITagOption[]) {
      return options.filter((option: ITagOption) => option.selected);
    },

    updateSelectedFilters(setFilter: string, selectedOptions: ITagOption[]) {
      this.$store.commit({
        type: setFilter,
        payload: selectedOptions
          .map((option: ITagOption) => option.name)
          .join(","),
      });
    },

    onSelectFilter(tagName: string) {
      switch (tagName) {
        case "Verksamhet":
          let operations = this.$store.getters.operations;
          let selectedOperations = this.getSelectedOptions(operations);
          this.updateSelectedFilters(
            "setOperations",
            selectedOperations
          );
          break;

        // case "Yrkeskategori":
        //   let professions = this.$store.getters.professions;
        //   let selectedProfessions = this.getSelectedOptions(professions);
        //   this.updateSelectedFilters(
        //     "setProfessions",
        //     selectedProfessions
        //   );
        //   break;

        case "Ämne":
          let subjects = this.$store.getters.subjects;
          let selectedSubjects = this.getSelectedOptions(subjects);
          this.updateSelectedFilters(
            "setSubjects",
            selectedSubjects
          );
          break;

        case "Tema":
          let themes = this.$store.getters.themes;
          let selectedThemes = this.getSelectedOptions(themes);
          this.updateSelectedFilters(
            "setThemes",
            selectedThemes
          );
          break;

        case "Bloggnamn":
          let blogNames = this.$store.getters.blogNames;
          let selectedBlogNames = this.getSelectedOptions(blogNames);
          this.updateSelectedFilters(
            "setBlogNames",
            selectedBlogNames
          );
          break;
      }

      this.$store.dispatch(search(""));
    },
  },
  components: {},
});
</script>
